import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, NavigationEnd, Router, Event as RouterEvent } from '@angular/router';
import { AuthenticationService } from '@core/authentication';
import { combineLatest, filter, map, tap } from 'rxjs';
import { InfoDialogListenerService } from './features/dialog-info/services/info-dialog-listener.service';
import { getCookie, setCookie } from '@helpers/functions';
import { UtmValidator } from '@helpers/validators';
import { FormControl } from '@angular/forms';
import dayjs from 'dayjs';

const UTM_SOURCE_EXPIRATION_DAYS = 30;

@Component({
    selector: 'app-root',
    template: `
        <router-outlet *ngIf="loaded$ | async; else loading"></router-outlet>
        <ng-template #loading>
            <app-loader></app-loader>
        </ng-template>
    `,
    styles: [],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    private loadingUser$ = this.authentication.user().pipe(map(() => true));

    private loadingData$ = this.router.events.pipe(
        filter(e => e instanceof NavigationEnd || e instanceof NavigationStart),
        tap(event => this.saveUtmSource(event)),
        map(() => true)
    );

    protected loaded$ = combineLatest([this.loadingData$, this.loadingUser$]).pipe(map(([l1, l2]) => l1 && l2));

    constructor(
        private readonly authentication: AuthenticationService,
        private readonly router: Router,
        private infoDialogListener: InfoDialogListenerService
    ) { }

    public ngOnInit(): void {
        this.infoDialogListener.init();
    }

    public ngOnDestroy(): void {
        this.infoDialogListener.destroy();
    }

    private saveUtmSource(event: RouterEvent): void {
        const url = new URL(
            (event as NavigationEnd).urlAfterRedirects
                ?? (event as NavigationStart).url
                ?? (event as NavigationEnd).url
                ?? '',
                window.location.origin
        );

        const utm = url.searchParams.get('utm_source');

        if (utm && this.isValidUtmSource(utm) && getCookie('utm_source') !== utm) {
            setCookie('utm_source', utm, dayjs().add(UTM_SOURCE_EXPIRATION_DAYS, 'days').toDate().toUTCString(), '/', true);
        }
    }

    private isValidUtmSource(utmSource: string): boolean {
        const validator = UtmValidator.source();
        const control = new FormControl(utmSource);

        return validator(control) === null;
    }
}
